export const wrapperStyles = { position: 'relative' };
export const cityWrapperStyles = { position: 'relative', width: '100%' };

export const getDropdownItemStyles = ({ palette }) => ({
  padding: '8px 16px',
  cursor: 'pointer',
  borderBottom: `1px solid ${palette.divider}`,
});

export const getDropdownItemActiveStyles = theme => ({
  ...getDropdownItemStyles(theme),
  backgroundColor: theme.palette.background.hoverDefault,
  boxShadow: `inset 3px 0 0 ${theme.palette.primary.main}`,
});
